const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the manager configuration directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerConfiguration', ['Application', function(Application) {
    return {
      restrict: 'E',
      scope: {
        user: '=',
        new: '@'
      },
      replace: true,
      template: require('../../../templates/directives/cms/manager-configuration.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.flags = Application.features.flags();
          var falseSegmentation = function () {
            var opts = {
              linked_locations: false,
              linked_departments: false,
              linked_teams: false,
              linked_grade: false,
              linked_org_level: false
            };

            if (self.flags.groups) {
              opts.groups = false;
            }

            return opts;
          };

          var additionalEditableFields = ['name', 'email', 'userid', 'title', 'language'];

          self.segmentationHeadings = {
            linked_teams: 'Teams',
            linked_departments: 'Department',
            linked_locations: 'Location',
            linked_grade: 'Grade',
            linked_org_level: 'Level',
            groups: 'Groups'
          };

          self.userFieldHeadings = {
            name: 'Name',
            email: 'Email',
            userid: 'External ID',
            title: 'Job Title',
            language: 'Language Support'
          };

          self.requiredSegmentation = falseSegmentation();
          self.restrictedSegmentation = falseSegmentation();
          self.hiddenOptions = falseSegmentation();
          self.restrictedEditable = {};

          additionalEditableFields.forEach(function(item) {
            self.restrictedEditable[item] = false;
          });

          self.onChange = function(value, type) {
            if (!value || !type || !self[type]) {
              return;
            }

            self.updateUser(type);
            if (!$scope.user.manager_configuration) {
              $scope.user.manager_configuration = {};
            }

            if (!$scope.user.manager_configuration.segmentation_required) {
              $scope.user.manager_configuration.segmentation_required = [];
            }

            if (!$scope.user.manager_configuration.segmentation_subset) {
              $scope.user.manager_configuration.segmentation_subset = [];
            }

            if (!$scope.user.manager_configuration.hide_options) {
              $scope.user.manager_configuration.hide_options = [];
            }

            if (!$scope.user.manager_configuration.restricted_editable_fields) {
              $scope.user.manager_configuration.restricted_editable_fields = [];
            }

          };

          self.updateUser = function(type) {
            if (!type || !self[type]) {
              return;
            }

            var userType = type === 'restrictedSegmentation' ? 'segmentation_subset' : type === 'requiredSegmentation' ? 'segmentation_required' : type === 'hiddenOptions' ? 'hide_options' : type === 'restrictedEditable' ? 'restricted_editable_fields' : '';
            if (!userType) {
              return;
            }

            $scope.user.manager_configuration[userType] = [];

            for (var key in self[type]) {
              if (self[type][key]) {
                $scope.user.manager_configuration[userType].push(key);
              }
            }

          };

          self.intialStates = function(list, directory) {
            if (list && list.length) {
              list.forEach(function(value) {
                directory[value] = true;
              });
            }
          };

          self.init = function () {
            if (!$scope.user.manager_configuration) {
              return;
            }

            self.intialStates($scope.user.manager_configuration.segmentation_required, self.requiredSegmentation);
            self.intialStates($scope.user.manager_configuration.segmentation_subset, self.restrictedSegmentation);
            self.intialStates($scope.user.manager_configuration.hide_options, self.hiddenOptions);
            self.intialStates($scope.user.manager_configuration.restricted_editable_fields, self.restrictedEditable);
          };

          if (!$scope.new) {
            self.init();
          }

        }],
      controllerAs: 'config'
    };
  }]);
